import { EntityAction, EntityActionFactory, EntityOp } from "@ngrx/data";
import { Store } from "@ngrx/store";
import { ApiPayload, ApiResponse } from "@recore-solutions/nstar-lib";

export function dispatchRelatedRecordActions(
	store: Store,
	entityActionFactory: EntityActionFactory,
	entityOp: EntityOp = EntityOp.ADD_MANY
) {
	return (payload: Pick<ApiPayload<any, any[]>, "related">): void => {
		if (!!store) {
			mapRelatedRecordsToActions(
				entityActionFactory,
				entityOp
			)(payload).forEach((a) => store?.dispatch(a));
		}
	};
}

function mapRelatedRecordsToActions(
	entityActionFactory: EntityActionFactory,
	entityOp: EntityOp = EntityOp.ADD_MANY
) {
	return (payload: Pick<ApiPayload<any, any[]>, "related">): EntityAction[] => {
		if (!entityActionFactory) {
			return [];
		}
		return (payload.related || []).map(mapApiResponseToActions(entityActionFactory, entityOp));
	};
}

function mapApiResponseToActions(
	entityActionFactory: EntityActionFactory,
	entityOp: EntityOp = EntityOp.ADD_MANY
) {
	return <T>(apiResponse: Pick<ApiResponse<T>, "recordType" | "records">): EntityAction => {
		return entityActionFactory.create(apiResponse.recordType, entityOp, apiResponse?.records || []);
	};
}
